export function convertToQueryString(obj, parentKey = '') {
    let queryString = '';

    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            const newKey = parentKey ? `${parentKey}[${key}]` : key;

            if (typeof value === 'object' && value !== null) {
                queryString += convertToQueryString(value, newKey);
            } else {
                queryString += `&${encodeURIComponent(newKey)}=${encodeURIComponent(value)}`;
            }
        }
    }

    return queryString;
}
